import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import Loader from "./components/Loader";
import EmpDash from "./components/EmpDash";
import { Link } from "react-router-dom";

function ProductList() {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productCollection = collection(db, "EMPLOYEES");
        const data = await getDocs(productCollection);

        setProducts(data.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // ✅ stop loading when done
      }
    };

    fetchData();
  }, []);

  // ✅ Show loading message until data fetch completes
  if (loading) return <Loader />;

  return (
    <div className="container mt-4">
      <div className="row">
        <h2 className="mb-4">Employee List</h2>
        {products.map((item) => (
          <div className="col-md-4 mb-4" key={item.id}>
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">{item.name}</h5>
                <p className="card-text">EMP ID: {item.mobile}</p>

                <Link
                  to={`/components/EmpDash/${item.mobile}`}
                  className="btn btn-primary"
                >
                  View
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default ProductList;
